import penImg from "../picture/Pen.png";
import twoParagraf from "../picture/TwoParagraf.png";
import leftPadding from "../picture/LeftPadding.png";
import centralPadding from "../picture/centralPadding.png";
import documentImg from "../picture/Document.png";
import editDocumentImg from "../picture/EditDocument.png";
import noteDocumentImg from "../picture/NoteDocument.png";
import uploadDocumentImg from "../picture/UploadDocument.png";
import folderUploadImg from "../picture/folderUpload.png";
import oneDocumentMaxImg from "../picture/oneDocumentMax.png";
import text43Img from "../picture/text4.3.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const SettingsEditorSegment6 = ({ data, handleCheckboxChange, handleSetValue }) => {

  if (!data) return null

  return (
    <div style={{display: "flex", gap: "30px"}}>
      <div className="se-segment6">
        <div className="se-segment6-buttons">
          <Button style={{width: "20%"}}>
            <img src={documentImg}/>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.create_document === false ? 0.5 : 1}}>
            <img src={editDocumentImg}/>
            <div className="se-segment6-buttons-circle" style={{color: "green"}}>24</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.upload_document === false ? 0.5 : 1}}>
            <img src={uploadDocumentImg}/>
            <div className="se-segment6-buttons-circle">25</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.report_document === false ? 0.5 : 1}}>
            <img src={noteDocumentImg}/>
            <div className="se-segment6-buttons-circle">26</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.folder_document === false ? 0.5 : 1}}>
            <img src={folderUploadImg}/>
            <div className="se-segment6-buttons-circle">27</div>
          </Button>
        </div>

        <div className="se-segment6-row1">
          <div style={{width: "20%"}}></div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="create_document"
              checked={data.create_document}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox" style={{color: "green"}}>24</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="upload_document"
              checked={data.upload_document}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">25</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="report_document"
              checked={data.report_document}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">26</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="folder_document"
              checked={data.folder_document}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">27</div>
          </div>
        </div>

        <div className="se-segment6-row2">
          <div className="one-checbox">
            <img src={oneDocumentMaxImg} style={{height: "30px", width: "70px"}}/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_size"
              checked={data["document_size"] == "5"}
              onChange={() => handleSetValue("5", "document_size")}
            />
            <div className="se-segment6-row2-number">5MB</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_size"
              checked={data["document_size"] == "50"}
              onChange={() => handleSetValue("50", "document_size")}
            />
            <div className="se-segment6-row2-number">50MB</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="edit_document"
              checked={data.edit_document}
              onChange={handleCheckboxChange}
            />
            <img src={penImg} style={{width: "20px", height: "20px"}}/>
            <div className="num-checkbox" style={{color: "green"}}>24</div>
            <div className="num-checkbox">25</div>
          </div>
        </div>

        <div className="se-segment6-row3">
          <div className="one-checbox">
            <input type="checkbox"
              name="document_length"
              checked={data["document_length"] == "50"}
              onChange={() => handleSetValue("50", "document_length")}
            />
            <div className="se-segment6-row3-number">50</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_length"
              checked={data["document_length"] == "n"}
              onChange={() => handleSetValue("n", "document_length")}
            />
            <div className="se-segment6-row3-number">n</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_align"
              checked={data["document_align"] == "LEFT"}
              onChange={() => handleSetValue("LEFT", "document_align")}
            />
            <img src={leftPadding} className="se-segment6-img"/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_align"
              checked={data["document_align"] == "CENTER"}
              onChange={() => handleSetValue("CENTER", "document_align")}
            />
            <img src={centralPadding} className="se-segment6-img"/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_rows"
              checked={data["document_rows"] == "2"}
              onChange={() => handleSetValue("2", "document_rows")}
            />
            <img src={twoParagraf} className="se-segment6-img"/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_rows"
              checked={data["document_rows"] == "n"}
              onChange={() => handleSetValue("n", "document_rows")}
            />
            <div className="se-segment6-row3-number">n</div>
          </div>
        </div>
      </div>
      <div>
        <img src={text43Img} style={{width: "100%", height: "120px"}}/>
      </div>
    </div>
  );
};

export default SettingsEditorSegment6;